import Phone from 'react-phone-number-input';
import countryList from '../../../store/locale/country-list';
import React from 'react';
import './PhoneNumberInputWrapper.scss';

// react-phone-number-input v1.x renders its own InputBasic (a class component)
// as the phone <input>. InputBasic is the required adapter: it receives the DOM
// event, parses event.target.value with parseIncompletePhoneNumber, formats the
// value for display, and only THEN calls Phone's onChange(parsedString) — Phone's
// onChange expects a parsed string, not a DOM event (see PhoneInput.onChange).
// It also already renders type="tel" + autoComplete="tel" and exposes .focus().
//
// We must NOT pass a custom inputComponent: doing so replaces InputBasic and
// wires the raw <input> onChange straight to Phone.onChange, which then treats
// the SyntheticEvent as a string (event[0], e164(event,...)) — so typing, paste
// and autofill all silently fail. That was the iOS "can't input phone number"
// regression introduced by inputComponent={<input/>}.
//
// MUI v9 passes a ref to this wrapper (it is slotProps.input.inputComponent).
// Give MUI the real DOM <input>, while keeping react-phone-number-input's
// default InputBasic adapter intact for parsing and formatting.
//
// type="tel" is placed after {...rest} so it overrides MUI TextField's default
// type="text" (which would otherwise flow through phoneNumberInputProps and beat
// InputBasic's own type='tel'). This makes iOS show the numeric phone keypad.
export const PhoneNumberInputWrapper = React.forwardRef(function PhoneNumberInputWrapper(props, ref) {
  const { className, onChange, intl, ownerState, ...rest } = props;

  const setInputRef = phone => {
    const input = phone?.number_input?.input || phone?.input?.input || phone?.input || phone;

    if (typeof ref === 'function') {
      ref(input);
    } else if (ref) {
      ref.current = input;
    }
  };

  return (
    <Phone
      ref={setInputRef}
      className={`phone-number-input-wrapper${className ? ` ${className}` : ''}`}
      {...rest}
      type="tel"
      international={true}
      country="HK"
      onChange={value => onChange({ target: { name: props.name, value: value } })}
      countries={countryList.labels}
      flagsPath={'img/flags/'}
      indicateInvalid
      smartCaret={false}
    />
  );
});
